<div class="skeleton" [ngClass]="skeletonModifier" [ngStyle]="{'width': width, 'height': height}"></div>
